export default "/images/de-pp-logo-200px.png?c8e3de8d3822b1690d30876a24bef5e1";